import React from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import {
  PLACE_TYPE_NAME_CHOISE,
  PLACE_TYPE_COLOR_CHOISE,
} from "../../constans";

const Wrapper = styled(Box)(() => ({
  position: "absolute",
  left: "20px",
  bottom: "14.5px",
}));

const PlaceType = styled(Typography)((color) => ({
  marginBottom: "2px",
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "14px",
  lineHeight: 1.214,
  color: color,
}));

const StopName = styled(Typography)(() => ({
  fontFamily: "Rubik",
  fontWeight: 500,
  fontSize: "24px",
  lineHeight: 1.35,
  color: "#ffffff",
}));

const StopNameBlock = ({ placeType, name }) => {
  return (
    <Wrapper>
      <PlaceType color={PLACE_TYPE_COLOR_CHOISE[placeType]}>
        {PLACE_TYPE_NAME_CHOISE[placeType]}
      </PlaceType>
      <StopName>{name}</StopName>
    </Wrapper>
  );
};

export default StopNameBlock;
